export type FxExtractionWorkflow = 'pci' | 'breaklines';

export const FX_EXTRACTION_WORKFLOWS: readonly FxExtractionWorkflow[] = [
  'pci',
  'breaklines',
];
